import React from "react";
import styled from "styled-components";

import { Person as PersonIcon } from "@material-ui/icons";
import { FlexSpacer } from "js/react/components/Gap";

const Container = styled.div.attrs(({ visible }) => ({
    style: {
        opacity: visible ? 100 : 0
    }
}))`
  position: absolute;
  top: -1px;
  left: 0;
  transition: opacity ease-in-out 0.5s;
  width: 100%;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  z-index: 75;
  background: rgba(0, 0, 0, 0.85);
`;

const PresentationName = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  white-space: nowrap;
  line-height: 36px;
  font-weight: 400;
  letter-spacing: 3px;
  text-transform: uppercase;
`;

const CreatorContainer = styled.div`
  display: flex;
  align-items: center;
  height: 30px;

  > img {
    border-radius: 50%;
    height: 30px;
    width: 30px;
    float: left;
    margin-right: 10px;
  }

  > svg {
    color: #ccc;
    font-size: 30px;
    margin-right: 10px;
  }

  > span {
    color: rgba(255, 255, 255, 0.7);
    font-size: 13px;
    letter-spacing: 1px;
    font-weight: 400;
    white-space: nowrap;
  }
`;

function PlayerInfoBar({ presentation, creator, visible }) {
    if (!presentation.get("showTitle") && !presentation.get("showAuthor")) return null;

    return (
        <Container visible={visible}>
            {presentation.get("showTitle") &&
                <PresentationName data-testing-info="deck-presentation-name">{presentation.get("name")}</PresentationName>
            }
            <FlexSpacer />
            {presentation.get("showAuthor") &&
                <CreatorContainer>
                    {creator?.photoURL && <img src={creator.photoURL}></img>}
                    {!creator?.photoURL && <PersonIcon />}
                    <span>{creator?.displayName}</span>
                </CreatorContainer>
            }
        </Container>
    );
}

export default PlayerInfoBar;
